import { trimToFiveDecimals } from "./trimToFiveDecimals";

export const findMinMaxRescale = (percentRange, min, max) => {
  const adjustedMin = trimToFiveDecimals(min);
  const adjustedMax = trimToFiveDecimals(max);

  const [percentMin, percentMax] = percentRange;

  const rescale_min =
    adjustedMin + ((adjustedMax - adjustedMin) * percentMin) / 100;
  const rescale_max =
    adjustedMin + ((adjustedMax - adjustedMin) * percentMax) / 100;

  return { rescale_min, rescale_max };
};
